<template>
    <div>
        <video ref="videoPlayer" class="video-js" playsinline></video>
        <div class="videoControls">
            <div class="videoControls-wrapper">
                <div class="videoControls-wrapper-button" v-for="(moment, index) in this.moments"
                     :key="index">
                    <transition-group name="fade">
                        <button class="videoControls-wrapper-button-btn" :class="{activeState: activeState(selectedChoice)}" v-show="showChoice(index)" :key="choice.name" v-for="(choice, selectedChoice) in moment.choices" @click="goToMoment(selectedChoice, choiceIndex)">{{choice.name}}</button>
                    </transition-group>
                </div>
                <p>{{this.currentTime}}</p>
                <!--<div class="progressBar" :style="{width: progressBarWidth}"></div>-->
                <div class="videoControls-wrapper-circle">
                    <svg viewBox="0 0 50 50" class="progressCircle" :class="{progressVisible : progressCircleVisible}">
                        <circle  r="20" cx="25" cy="25" stroke-dasharray="200" :stroke-dashoffset="progressCircle" fill="none" stroke="#CEDC00" transform="rotate(-90 25 25)"></circle>
                    </svg>
                </div>

            </div>
        </div>
        <div class="pancarte" :class="{visible: showPancarte()}">
            <div class="pancarte-wrapper">
                <button class="replay-button" @click="replayVideo">Herbekijken</button>
                <a href="https://www.facebook.com/sharer/sharer.php?u=https://joe.be/nieuws/clouseau-verwent-2-uur-lang-luisteraars-tijdens-exclusieve-joe-live" target="_blank">Deel op Facebook</a>
            </div>
        </div>
    </div>
</template>

<script>
    import videojs from 'video.js';
    import axios from 'axios';

    export default {
        name: "VideoPlayer",
        props: ['options'],
        data() {
            return {
                player: null,
                moments: {},
                currentTime: 0,
                choiceIndex: 0,
                nextChoiceTime: null,
                nextChoice: '',
                hasChosen: false,
                progressBarWidth: 100,
                progressCircle: 200,
                progressCircleVisible: false,
                selectedChoiceInMoment: 0,
                hasSkippedToNextMoment: false,
                skipMomentIndex: 0,
                leewayInMs: 500,
                isEnded: false
            }
        },
        methods: {
          goToMoment(selectedChoice, choiceIndex){
              let nextMoment = this.moments[choiceIndex]
              this.selectedChoiceInMoment = selectedChoice
              this.nextChoiceTime = nextMoment.choices[selectedChoice].start_time
              this.hasChosen = true

          },
            checkChoice(index){
              let nextMoment = this.moments[index]
                //console.log(nextMoment.choice_time)
              if(this.currentTime  >  nextMoment.choices[0].start_time - this.leewayInMs && this.hasChosen){
                  //console.log('first')
                  this.player.currentTime(this.nextChoiceTime / 1000);
                  this.nextChoiceTime = null;
                  this.choiceIndex++;
                  this.hasChosen = false;
                  this.hasSkippedToNextMoment = false;
                  this.progressCircleVisible = false;
                  this.sendGtmChoice(index);
              } else if (this.currentTime  >  nextMoment.choices[0].start_time - this.leewayInMs && !this.hasChosen) {
                  //console.log('second')
                  this.nextChoiceTime = nextMoment.choices[0].start_time;
                  this.selectedChoiceInMoment = 0;
                  this.player.currentTime(this.nextChoiceTime / 1000);
                  this.nextChoiceTime = null;
                  this.choiceIndex++;
                  this.hasChosen = false;
                  this.hasSkippedToNextMoment = false;
                  this.progressCircleVisible = false;
                  this.sendGtmChoice(index);
              }
            },
            showChoice(index){
                let nextMoment = this.moments[index]

                if (this.currentTime  >  nextMoment.choices[0].start_time - nextMoment.choice_time - this.leewayInMs && this.currentTime  <  nextMoment.choices[0].start_time - this.leewayInMs){
                    this.progressCircleVisible = true
                    return true
                } else {
                    return false
                }
            },
            progressBarWidthCalc(index){
                let nextMoment = this.moments[index]
                let progress = (nextMoment.choices[0].start_time - this.currentTime) / (nextMoment.choice_time) * 100
                if (progress > 100){
                    return 100
                } else {
                    return progress
                }

            },
            progressCircleWidthCalc(index){
                let nextMoment = this.moments[index]
                let progress = 200 - (nextMoment.choices[0].start_time - this.currentTime -  this.leewayInMs) / (nextMoment.choice_time) * 125
                //if(progress > )
                return progress

            },
            skipMomentAfterPlay(momentToSkipIndex){
              //console.log(momentToSkipIndex)
                //console.log('selected: ' + this.selectedChoiceInMoment)
                //console.log('moment to skip index:' + momentToSkipIndex)
                let momentToCheck = this.moments[momentToSkipIndex]

                  //console.log( momentToCheck)
                  //console.log(momentToCheck.choices[this.selectedChoiceInMoment].end_time)
                  //console.log(this.currentTime)
                  if(this.currentTime > momentToCheck.choices[this.selectedChoiceInMoment].end_time && !this.hasSkippedToNextMoment){
                      //console.log(momentToCheck.choices[this.selectedChoiceInMoment].end_time)
                      //console.log(this.currentTime)
                      //console.log('this runs')
                      this.player.currentTime(((momentToCheck.choices[momentToCheck.choices.length -1].end_time + this.leewayInMs) / 1000))
                      this.selectedChoiceInMoment = 0
                      this.hasSkippedToNextMoment = true
                      this.skipMomentIndex++;
                  }
            },
            resetParams(){
                this.currentTime = 0
                this.choiceIndex = 0
                this.nextChoiceTime = null
                this.nextChoice = ''
                this.hasChosen = false
                this.progressBarWidth = 100
                this.selectedChoiceInMoment = 0
                this.hasSkippedToNextMoment = false
                this.skipMomentIndex = 0
            },
            activeState(index){
                if(index === this.selectedChoiceInMoment && this.hasChosen){
                    return true
                } else {
                    return false
                }
            },
            showPancarte(){
                return this.isEnded;
            },
            replayVideo(){
              //console.log('this runs')
              this.resetParams();
              this.isEnded = false;
              this.showPancarte();
              this.player.play();
            },
            sendGtmChoice(step){
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({

                    'event':'VirtualPageview',

                    'virtualPageURL':`/joe-live/keuze${step + 1}`,

                    'virtualPageTitle' : `Keuze ${step + 1} - Joe LIVE`

                });
            },
            sendGtmPlay(){
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({

                    'event':'VirtualPageview',

                    'virtualPageURL':`/joe-live/play`,

                    'virtualPageTitle' : `Play - Joe LIVE`

                });
            }
        },
        computed: {

        },
        watch: {
            currentTime(oldVal, newVal){
                //console.log(this.choiceIndex)
                if(this.choiceIndex < this.moments.length){
                    this.progressBarWidth = `${this.progressBarWidthCalc(this.choiceIndex)}%`;
                    this.progressCircle = this.progressCircleWidthCalc(this.choiceIndex);
                    this.checkChoice(this.choiceIndex);
                }

                if(this.skipMomentIndex < this.moments.length){
                    this.skipMomentAfterPlay(this.skipMomentIndex);
                }

                //console.log(newVal)

            },
        },
        mounted() {
            let vm = this;
            axios.get("https://static.qmusic.be/joe/interactive-video/joe-live-times-4.json").then(function (response){
                //console.log(response.data.moments)
                vm.moments = response.data.moments;
            }).catch(function (error){
                console.log(error)
            });
            this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
                console.log('onPlayerReady', this);
                this.on('timeupdate', function(){
                    vm.currentTime = this.currentTime() * 1000
                })
                this.on('ended', function(){
                    vm.resetParams()
                    vm.isEnded = true;
                    vm.showPancarte()
                })
                this.on('play', function() {
                    vm.isEnded = false;
                    vm.showPancarte()
                    vm.sendGtmPlay()
                })
            })

        },
        beforeDestroy() {
            if (this.player) {
                this.player.dispose()
            }
        }
    }
</script>

<style scoped lang="scss">

    p{
        color: white;
        font-size: 30px;
    }

    .progressBar{
        height: 20px;
        background: green;
        display: block;
    }



    .progressCircle{
        display: none;

            circle{

                transition: all 0.2s linear;
                stroke-width: 5%;

            }
    }

    .progressVisible{
        display: block;
    }

    .videoControls{
        position: absolute;
        width: 100%;
        padding-bottom: 56.25%;
        //background: red;
        pointer-events: none;
        top: 0;

        &-wrapper{
            position: absolute;
            width: 70%;
            margin: 0 15%;
            bottom: 18%;
            z-index: 10;


            p{
                display: none;
            }

            &-button{

                display: flex;
                flex-direction: row;

                span{
                    //flex: 1;
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                }

                &-btn{
                    pointer-events: auto;
                    padding: 3% 6% 3% 7%;
                    background: #CEDC00;
                    font-family: 'Geomanist', Arial, sans-serif;
                    color: #094C59;
                    font-weight: 600;
                    border: 0;
                    border-radius: 500px;
                    font-size: 14px;
                    flex: 1;
                    margin: 0 5%;
                    cursor: pointer;
                    transition: background, color 0.2s ease-in;

                    &:hover{
                        background: #C3D000;
                    }

                    &:focus{
                        outline: none;
                        background: #14A08C;
                        color: white;
                    }
                }
            }

            &-circle{
                position: absolute;
                width: 10%;
                left: 50%;
                bottom: -15%;
                transform: translateX(-50%),

            }
        }
    }

    .pancarte{
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        padding-bottom: 56.25%;
        background: rgba(0,0,0,0.5);
        transition: display 0.3s ease-in;

        &-wrapper{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            width: 40%;

            button{
                pointer-events: auto;
                padding: 5% 6% 5% 6%;
                background: #CEDC00;
                font-family: 'Geomanist', Arial, sans-serif;
                color: #094C59;
                font-weight: 600;
                border: 0;
                border-radius: 500px;
                font-size: 14px;
                flex: 1;
                margin: 0 5%;
                cursor: pointer;
                transition: background, color 0.2s ease-in;

                &:hover{
                    background: #C3D000;
                }

                &:focus{
                    outline: none;
                    background: #14A08C;
                    color: white;
                }
            }

            a{
                pointer-events: auto;
                padding: 5% 6% 5% 6%;
                background: #CEDC00;
                font-family: 'Geomanist', Arial, sans-serif;
                color: #094C59;
                font-weight: 600;
                border: 0;
                border-radius: 500px;
                font-size: 14px;
                flex: 1;
                margin: 0 5%;
                cursor: pointer;
                transition: background, color 0.2s ease-in;
                text-decoration: none;
                text-align: center;
                margin-top: 5%;

                &:hover{
                    background: #C3D000;
                }

                &:focus{
                    outline: none;
                    background: #14A08C;
                    color: white;
                }
            }
        }


    }

    .activeState{
        color: #fff;
        background: #14A08C;
    }

    .visible{
        display: block;
        transition: display 0.3s ease-in;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

</style>
